(() => {
  const setup = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.dataset.bbmcVariantGallery = '20261009';
    // The legacy gallery remains in the DOM for Empire's product controller,
    // but the app gallery takes the visible gallery position.
    const nativeGallery = document.querySelector('[data-product-gallery]');
    if (nativeGallery && !nativeGallery.dataset.bbmcGalleryReplaced) {
      nativeGallery.before(root);
      nativeGallery.dataset.bbmcGalleryReplaced = 'true';
      nativeGallery.style.display = 'none';
    }
    const viewport = root.querySelector('[data-bbmc-gallery-viewport]');
    const slides = [...root.querySelectorAll('[data-bbmc-gallery-slide]')];
    const thumbs = [...root.querySelectorAll('[data-bbmc-gallery-thumbnail]')];
    const dialog = root.querySelector('[data-bbmc-gallery-dialog]');
    const dialogImage = root.querySelector('[data-bbmc-gallery-dialog-image]');
    if (!viewport || !slides.length) return;

    let activeIndex = 0;
    const updateActiveState = (index, { revealThumbnail = false } = {}) => {
      const target = slides[index];
      if (!target) return;
      activeIndex = index;
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
      thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', String(active));
        if (active && revealThumbnail) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
      [slides[index - 1], slides[index + 1]].forEach((slide) => {
        const image = slide?.querySelector('img[loading="lazy"]');
        if (image) image.loading = 'eager';
      });
    };
    const select = (index, { revealThumbnail = true, behavior = 'smooth' } = {}) => {
      const target = slides[index];
      if (!target) return;
      updateActiveState(index, { revealThumbnail });
      viewport.scrollTo({ left: target.offsetLeft, behavior });
    };

    let viewportWidth = viewport.clientWidth;
    new ResizeObserver(() => {
      if (viewport.clientWidth === viewportWidth) return;
      viewportWidth = viewport.clientWidth;
      select(activeIndex, { revealThumbnail: false, behavior: 'instant' });
    }).observe(viewport);
    let ticking = false;
    viewport.addEventListener('scroll', () => {
      if (ticking || viewport.clientWidth !== viewportWidth) return;
      ticking = true;
      requestAnimationFrame(() => {
        const index = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
        if (index !== activeIndex) updateActiveState(index);
        ticking = false;
      });
    }, { passive: true });
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));

    root.querySelectorAll('[data-bbmc-gallery-zoom]').forEach((button) => button.addEventListener('click', () => {
      const image = button.querySelector('img');
      if (!image || !dialog || !dialogImage) return;
      dialogImage.src = image.currentSrc || image.src;
      dialogImage.alt = image.alt;
      dialog.showModal();
    }));
    root.querySelector('[data-bbmc-gallery-dialog-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

    const variants = JSON.parse(root.querySelector('[data-bbmc-gallery-variants]')?.textContent || '[]');
    document.querySelectorAll('variant-selection,[data-variant-selection]').forEach((selector) => selector.addEventListener('variant-change', (event) => {
      if (!variants.some((variant) => String(variant.id) === String(event.detail?.variant?.id))) return;
      const mediaId = event.detail?.variant?.featured_media?.id;
      const index = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
      if (index >= 0) select(index, { revealThumbnail: false, behavior: 'instant' });
    }));
    const queryId = new URLSearchParams(location.search).get('variant');
    const selectedId = queryId || [...document.querySelectorAll('form[action*="/cart/add"] [name="id"]')].map((field) => field.value).find((id) => variants.some((variant) => String(variant.id) === String(id)));
    const selected = variants.find((variant) => String(variant.id) === String(selectedId));
    const initialIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(selected?.featured_media?.id));
    select(Math.max(0, initialIndex), { revealThumbnail: false, behavior: 'instant' });
  };
  document.querySelectorAll('[data-bbmc-product-media-gallery]').forEach(setup);
})();
